import React from "react";
import { Skeleton } from "@triporate/triporate-design-system";

const LoadingBody = (): JSX.Element => (
  <Skeleton paragraph={{ rows: 5 }} active />
);

export default LoadingBody;
